// A walk step drawn off its row: the whole figure (body, hair, clothes) moves by this many of the sheet's px in that
// frame, the sheet's own way round (a mirrored row moves the other way). Ken walking front34 29 stands ~6 px right of
// steps 28 and 30 in today's art (owner 2026-11-02: "slightly to the left compared than the rest", seen walking SE).
const STEP_SHIFT = { ken: { 29: -6 } };

/** Sheet px the figure moves right in walk `frame` (mirrored when `flip`); 0 for a step drawn in line. */
export function stepShift(character, frame, flip) {
  const px = STEP_SHIFT[character]?.[Number(frame)] ?? 0;
  return flip ? -px : px;
}
